import { inject } from 'vue-demi'
import type { SmartblockActivationOptions } from '../../types'

export const SmartblockActivationOptionsInjectKey = 'smartblockOptions'

export function useSmartblockOptions (): SmartblockActivationOptions {
  const injectOptions = inject<SmartblockActivationOptions | undefined>(SmartblockActivationOptionsInjectKey, undefined)
  const options = {
    defaultBlockStyle: injectOptions?.defaultBlockStyle,
    defaultVersion: injectOptions?.defaultVersion ?? import.meta.env.VITE_SMARTBLOCK_DEFAULT_VERSION
  } satisfies SmartblockActivationOptions
  return options
}
